import { AdaaHelper } from "../../core/utils";
import { Constants } from "../../shared/constants/constants";
import { AttachFile, WorkflowDecisionModelType, WorkflowDiffInputType } from "../../shared/models";
import { NotificationCommunication, SearchFields } from "../../shared/models/notification-center-model";

export const buildNotificationSearchFields = (term: string): SearchFields => ({
  title_en: { value: term, order: null },
  title_ae: { value: term, order: null },
  comm_msg_ae: { value: term, order: null },
  comm_msg_en: { value: term, order: null },
});

export const canReviewNotification = (notification: NotificationCommunication | undefined): boolean => {
  if (!notification) return false;
  if (notification.commType !== "I") return true;

  return +notification.wfActionType === Constants.NOTIFICATION_ACTION_TYPES.UPDATE;
};

export const notificationReviewInput = (notification: NotificationCommunication): WorkflowDiffInputType =>
  ({
    itemId: notification.itemId,
    trailId: notification.auditTrailId,
    itemTypeId: notification.itemType,
    readingType: notification.readingType,
    wfActionType: notification.wfActionType,
    wfProcessCtlId: notification.wfProcessCtlId,
  }) as unknown as WorkflowDiffInputType;

export const buildNotificationDecision = ({
  notification,
  approval,
  attachment,
  decision,
}: {
  notification: NotificationCommunication;
  approval: boolean;
  attachment: AttachFile | null;
  decision: Partial<WorkflowDecisionModelType> | undefined;
}) => {
  const currentUserId = AdaaHelper.getLocalStorage(Constants.localStorageKeys.user, {
    type: "prop",
    property: "id",
  });

  return {
    wfProcessCtlId: notification.wfProcessCtlId,
    wfProcessCtlStepId: notification.wfProcessCtlStepId,
    stepDecision: approval ? Constants.WF_ACTION_DECISION.APPROVED : Constants.WF_ACTION_DECISION.REJECTED,
    threadId: notification.threadId,
    itemId: notification.itemId,
    itemTypeId: notification.itemType,
    itemAttachmentId: attachment?.id,
    categorizedComments: decision?.categorizedComments ?? [],
    userId: +currentUserId,
  };
};
